module.exports = __webpack_public_path__ + "img/swiper-bg-mobile1.dd6dc2dc.jpg";